import { api } from "@/api";
import { getStoreAccessors } from "typesafe-vuex";
import { ActionContext } from "vuex";
import { State } from "../state";
import {
  commitSetProjects,
  commitSetProject,
  commitDeleteProject,
  commitSetMyProjects,
  commitSetProjectScenes,
  commitSetProjectUsers,
  commitSetHokSkinDevices,
  commitSetTopMainLabelPerformance,
  commitSetHokSkinDataPage,
  commitSetProjectUser,
  commitSetTopCpuList,
  commitSetHokDeviceList,
  commitSetHokSkinData,
  commitSetHokDeviceOutList,
  commitSetHokInAdd,
  commitSetHokIcon,
  commitSetHokOutAdd,
  commitSetTestAppointmentTable,
  commitSetProjectSgameSkinList,
  commitSetHokInV1,
  commitSetHokInAddV1,
  commitSetHokOutV1,
  commitSetHokOutAddV1,
  commitSetModelList,
  commitSetModelOptions,
  commitSetTestAppointmentTableAll,
  commitSetHokOut,
  commitSetHokInSkinTrend,
  commitSetProjectScene,
  commitSetTopSceneList,
  commitSetTopPerformance,
  commitSetProjectDetail,
  commitSetHokOutSkinTrend,
  commitSetReportStat,
  commitSetTopPerformanceList,
  commitSetHokIn,
  commitSetTopSceneListVersion,
  commitSetTopProblemByCpu,
  commitSetTopProblemSummary,
  commitSetTopModelListVersion,
  commitSetTopVersionListVersion,
  commitSetTopVersionListProblem,
  commitSetTopProjectList,
  commitSetTopVersionData,
  commitSetTestAppointmentAdamins,
  commitSetVisitStatistics,
  commitSetTopProjectType,
  commitSetVisitStatTrend,
  commitSetTopOptions,
  commitSetCreateProjectScenes,
  commitSetTopVersionList,
  commitSetProjectScenesPage,
  commitSetTopProjectScenes,
  commitSetTopLabelPerformance,
  commitSetTopProjectPerformance,
  commitSetMonitorTrend,
  commitSetMonitorList,
  commitSetTopPerformanceListAdvance,
  commitSetTopModelPerformance,
  commitSetMonitorUploadTrend,
  commitSetMonitorUploadList,
  commitSetTopLevelPerformance,
  commitSetTopTesterPerformance,
  commitSetTopPerformanceOld,
  commitSetTestAppointment,
  commitSetGamesData,
  commitSetHokSkinVersions,
  commitSetCreateTopProjectScenes,
  commitSetGamesDate,
  commitSetTopModelList,
} from "./mutations";
import { ProjectState } from "./state";
import { AxiosError } from "axios";
import {
  ICreateScript,
  IProject,
  ICreateTopScript,
  IProjectScene,
  IProjectUser,
  IDeviceModelList,
  AppointmentCreat
} from "@/interfaces";
import { dispatchCheckApiError } from "../task/actions";
import { store } from "..";
import { ElMessage } from "element-plus";

type ProjectContext = ActionContext<ProjectState, State>;

export const actions = {
  async actionGetProjects(
    context: ProjectContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getProjects(
        context.rootState.main.token,
        payload.project
      );
      if (response) {
        commitSetProjects(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetProjectDetail(
    context: ProjectContext,
    payload: { id: number; project: number }
  ) {
    try {
      const response = await api.getProject(
        context.rootState.main.token,
        payload.id,
        payload.project
      );
      if (response) {
        commitSetProjectDetail(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetGamesDate(
    context: ProjectContext,
    payload: { type : number;}
  ) {
    try {
      const response = await api.getGamesDate(
        context.rootState.main.token,
        payload.type,
      );
      if (response) {
        commitSetGamesDate(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetGamesTap(
    context: ProjectContext,
   
  ) {
    try {
      const response = await api.getGamesTap(
        context.rootState.main.token,
        
      );
      if (response) {
        return response.data
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokIcon(
    context: ProjectContext,
    payload: { project : number;}
  ) {
    try {
      const response = await api.getHokIcon(
        context.rootState.main.token,
        payload.project,
      );
      if (response) {
        commitSetHokIcon(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokSkinVersions(
    context: ProjectContext,
    payload: { project : number;}
  ) {
    try {
      const response = await api.getHokSkinVersions(
        context.rootState.main.token,
        payload.project,
      );
      if (response) {
        commitSetHokSkinVersions(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokSkinDevices(
    context: ProjectContext,
    payload: { project : number;type:any}
  ) {
    try {
      const response = await api.getHokSkinDevices(
        context.rootState.main.token,
        payload.project,
        payload.type,
      );
      if (response) {
        commitSetHokSkinDevices(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokSkinData(
    context: ProjectContext,
    payload: { project : number;version:any,type:any,action:any,hero_skin:any,device:any,start_date:any,end_date:any,order_by:any,reverse:any,page:any,page_size:any,is_pass:any, level?:any}
  ) {
    try {
      const response = await api.getHokSkinData(
        context.rootState.main.token,
        payload.project,
        payload.version,
        payload.type,
        payload.action,
        payload.hero_skin,
        payload.device,
        payload.start_date,
        payload.end_date,
        payload.order_by,
        payload.reverse,
        payload.page,
        payload.page_size,
        payload.is_pass,
        payload.level,
      );
      if (response) {
        commitSetHokSkinData(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokSkinDataPage(
    context: ProjectContext,
    payload: { project : number;version:any,type:any,action:any,hero_skin:any,device:any,start_date:any,end_date:any,order_by:any,reverse:any,page:any,is_pass:any}
  ) {
    try {
      const response = await api.getHokSkinDataPage(
        context.rootState.main.token,
        payload.project,
        payload.version,
        payload.type,
        payload.action,
        payload.hero_skin,
        payload.device,
        payload.start_date,
        payload.end_date,
        payload.order_by,
        payload.reverse,
        payload.page,
    
        payload.is_pass,
     
      );
      if (response) {
        commitSetHokSkinDataPage(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokSkinDataExport(
    context: ProjectContext,
    payload: { project : number;version:any,type:any,action:any,hero_skin:any,device:any,start_date:any,end_date:any,order_by:any,reverse:any,page:any,page_size:any,is_pass:any}
  ) {
    try {
      const response = await api.getHokSkinDataExport(
        context.rootState.main.token,
        payload.project,
        payload.version,
        payload.type,
        payload.action,
        payload.hero_skin,
        payload.device,
        payload.start_date,
        payload.end_date,
        payload.order_by,
        payload.reverse,
        payload.page,
        payload.page_size,
        payload.is_pass,
     
      );
      if (response) {
       return response.data
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokIn(
    context: ProjectContext,
      payload: { project : number; skin_id: any, gender?: any }
   
  ) {
    try {
      const response = await api.getHokIn(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.gender,
      );
      if (response) {
        commitSetHokIn(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokInV1(
    context: ProjectContext,
      payload: { project : number; skin_id: any, }
   
  ) {
    try {
      const response = await api.getHokInV1(
        context.rootState.main.token,
        payload.project,
        payload.skin_id
        
      );
      if (response) {
        commitSetHokInV1(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokInAdd(
    context: ProjectContext,
      payload: { project : number; skin_id: any,device_name:any,page:any,quality:any }
   
  ) {
    try {
      const response = await api.getHokInAdd(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.device_name,
        payload.page,
        payload.quality
        
      );
      if (response) {
        commitSetHokInAdd(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokInAddV1(
    context: ProjectContext,
      payload: { project : number; skin_id: any,device_name:any,page:any }
   
  ) {
    try {
      const response = await api.getHokInAddV1(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.device_name,
        payload.page
        
      );
      if (response) {
        commitSetHokInAddV1(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokOutAdd(
    context: ProjectContext,
      payload: { project : number; skin_id: any,device_name:any,page:any,action:any }
   
  ) {
    try {
      const response = await api.getHokOutAdd(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.device_name,
        payload.page,
        payload.action
        
      );
      if (response) {
        commitSetHokOutAdd(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokOutAddV1(
    context: ProjectContext,
      payload: { project : number; skin_id: any,device_name:any,page:any,action:any }
   
  ) {
    try {
      const response = await api.getHokOutAddV1(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.device_name,
        payload.page,
        payload.action
        
      );
      if (response) {
        commitSetHokOutAddV1(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokOut(
    context: ProjectContext,
      payload: { project : number; skin_id: any, gender ?: any }
   
  ) {
    try {
      const response = await api.getHokOut(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.gender,
      );
      if (response) {
        commitSetHokOut(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokOutV1(
    context: ProjectContext,
      payload: { project : number; skin_id: any, }
   
  ) {
    try {
      const response = await api.getHokOutV1(
        context.rootState.main.token,
        payload.project,
        payload.skin_id
        
      );
      if (response) {
        commitSetHokOutV1(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokDeviceList(
    context: ProjectContext,
      payload: { project : number; skin_id: any,type:any }
   
  ) {
    try {
      const response = await api.getHokDeviceList(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.type,
        
        
      );
      if (response) {
        commitSetHokDeviceList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokDeviceOutList(
    context: ProjectContext,
      payload: { project : number; skin_id: any,type:any }
   
  ) {
    try {
      const response = await api.getHokDeviceList(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.type,
        
        
      );
      if (response) {
        commitSetHokDeviceOutList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetModelList(
    context: ProjectContext,
      payload: { search:any,oem:any,cpu_name:any,ram:any,borrower:any,page:any,size:any,gpu:any}
   
  ) {
    try {
      const response = await api.getModelList(
        context.rootState.main.token,
        
        payload.search,
        payload.oem,
        payload.cpu_name,
        payload.ram,
        payload.borrower,
        payload.page,
        payload.size,
        payload.gpu,
   
        
        
      );
      if (response) {
        commitSetModelList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetModelOptionst(
    context: ProjectContext,
      payload: { project:number,}
   
  ) {
    try {
      const response = await api.getModelOptions(
        context.rootState.main.token,
        payload.project,
  
   
        
        
      );
      if (response) {
        commitSetModelOptions(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokInSkinTrend(
    context: ProjectContext,
      payload: { project : number; skin_id: any,device_id:any,quality:any, gender?:any}
   
  ) {
    try {
      const response = await api.getHokInSkinTrend(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.device_id,
        payload.quality,
        payload.gender,
      );
      if (response) {
        commitSetHokInSkinTrend(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetModelCreate(
    context: ProjectContext,
      payload: IDeviceModelList
   
  ) {
    try {
      const response = await api.getModelCreate(
        context.rootState.main.token,
        payload
      );
      if (response) {
        return response.data
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetModelEdit(
    context: ProjectContext,
      payload: IDeviceModelList
   
  ) {
    try {
      const response = await api.getModelEdit(
        context.rootState.main.token,
        payload
      );
      if (response) {
        return response.data
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetModelStatus(
    context: ProjectContext,
      payload: {status:any,id:any,return_time?:any}
   
  ) {
    try {
      const response = await api.getModelStatus(
        context.rootState.main.token,
        payload
      );
      if (response) {
        return response.data
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetHokOutSkinTrend(
    context: ProjectContext,
      payload: { project : number; skin_id: any, action:any,device_id:any,quality:any, gender?:any}
   
  ) {
    try {
      const response = await api.getHokOutSkinTrend(
        context.rootState.main.token,
        payload.project,
        payload.skin_id,
        payload.action,
        payload.device_id,
        payload.quality,
        payload.gender,
      );
      if (response) {
        commitSetHokOutSkinTrend(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetGamesData(
    context: ProjectContext,
    payload: { date : string; last: string,type:any }
   
  ) {
    try {
      const response = await api.getGameData(
        context.rootState.main.token,
        payload.date,
        payload.last,
        payload.type
      );
      if (response) {
        commitSetGamesData(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  // async actionGetGamesSubscription(
  //   context: ProjectContext,
  //   payload: { project:any}
  // ) {
  //   try {
  //     const response = await api.getGamesSubscription(
  //       context.rootState.main.token,
  //       payload.project
        
  //     );
  //     if (response) {
  //      return response.data
  //     }
  //   } catch (error) {
  //     await dispatchCheckApiError(context, error);
  //   }
  // },
  async actionGetProjectScenes(
    context: ProjectContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getProjectScenes(
        context.rootState.main.token,
        payload.project
      );
      if (response) {
        commitSetProjectScenes(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopProjectScenes(
    context: ProjectContext,
    payload: { project: number }
  ) {
    try {
      const response = await api.getTopProjectScenes(
        context.rootState.main.token,
        payload.project
      );
      if (response) {
        commitSetTopProjectScenes(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetProjectScenesPage(
    context: ProjectContext,
    payload: { project: number; page: number; size: number; search: string }
  ) {
    try {
      const response = await api.getProjectScenesPage(
        context.rootState.main.token,
        payload.project,
        payload.page,
        payload.size,
        payload.search
      );
      if (response) {
        commitSetProjectScenesPage(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetProjectSgameSkinList(
    context: ProjectContext,
    payload: { project: number; page: number; size: number; search: string }
  ) {
    try {
      const response = await api.getProjectSgameSkinList(
        context.rootState.main.token,
        payload.project,
        payload.page,
        payload.size,
        payload.search
      );
      if (response) {
        commitSetProjectSgameSkinList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetCreateProjectSgameSkinList(
    context: ProjectContext,
    payload: { project: number, skinid: any, heroid: any, heroname: string,skin:any,skinname:any,desc:any,level:any, gender:any }
  ) {
    try {
      const response = await api.getCreateProjectSgameSkinList(
        context.rootState.main.token,
        payload,
      

       
      );
      if (response) {
        return response.data
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateProjectScene(
    context: ProjectContext,
    payload: IProjectScene
  ) {
    try {
      const response = (
        await Promise.all([
          api.updateProjectScene(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetProjectScene(context, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateSgameSkin(
    context: ProjectContext,
    payload: {project:any,id:any,skinid:any,heroid:any,heroname:any,skin:any,skinname:any,desc:any,level:any, gender: any}
  ) {
    try {
      const response = (
        await Promise.all([
          api.updateSgameSkin(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if(response.data){
        return response.data
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteProjectScene(
    context: ProjectContext,
    payload: { id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteProjectScene(
            context.rootState.main.token,
            payload.id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteSgameSkin(
    context: ProjectContext,
    payload: { id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteSgameSkin(
            context.rootState.main.token,
            payload.id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionCreateProjectScenes(
    context: ProjectContext,
    payload: ICreateScript
  ) {
    try {
      const response = (
        await Promise.all([
          api.createProjectScenes(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetCreateProjectScenes(context, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCreateTopProjectScenes(
    context: ProjectContext,
    payload: ICreateTopScript
  ) {
    try {
      const response = (
        await Promise.all([
          api.createTopProjectScenes(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetCreateTopProjectScenes(context, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateProject(
    context: ProjectContext,
    payload: { id: number; project: IProject }
  ) {
    try {
      const response = (
        await Promise.all([
          api.updateProject(
            context.rootState.main.token,
            payload.id,
            payload.project
          ),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetProject(context, response.data);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionDeleteProject(context: ProjectContext, payload: { id: number }) {
    try {
      const response = (
        await Promise.all([
          api.deleteProject(context.rootState.main.token, payload.id),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitDeleteProject(context, payload.id);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCreateProject(context: ProjectContext, payload: IProject) {
    try {
      const response = (
        await Promise.all([
          api.createProject(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetProject(context, response.data);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCreateProjectUser(
    context: ProjectContext,
    payload: IProjectUser
  ) {
    try {
      const response = (
        await Promise.all([
          api.createProjectUser(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetProjectUser(context, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionCloneProject(
    context: ProjectContext,
    payload: { old_project: number; new_project: number; clone_list: string[] }
  ) {
    try {
      ElMessage.warning(
        "克隆项目数据耗时可能很长, 请您耐心等待, 期间可以进行其他操作"
      );
      const response = (
        await Promise.all([
          api.cloneProject(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      if (response.data.status === 1) {
        ElMessage.success({
          message: "克隆项目数据完成",
          showClose: true,
          type: "success",
        });
      }
    } catch (error) {
      // ElMessage.error("克隆项目数据失败");
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetMyProjects(context: ProjectContext) {
    try {
      const response = await api.getMyProjects(context.rootState.main.token);
      if (response) {
        commitSetMyProjects(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionProjectAccess(context: ProjectContext) {
    try {
      const response = await api.projectAccess(context.rootState.main.token);
    } catch (error) {
      alert("项目接入请求发起失败，请联系管理员");
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetProjectUsers(context: ProjectContext, project: number) {
    try {
      const response = await api.getProjectUsers(
        context.rootState.main.token,
        project
      );
      if (response) {
        commitSetProjectUsers(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetProjectUsersPage(context: ProjectContext, payload: {
    project: number;
   
  }) {
    try {
      const response = await api.getProjectUsersPages(
        context.rootState.main.token,
        payload.project,
      );
      if (response) {
        return response.data
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetReportStat(
    context: ProjectContext,
    payload: {
      project: number;
      search: any | "";
      size: number | string;
      page: number;
    }
  ) {
    try {
      const response = await api.getReportStat(
        context.rootState.main.token,
        payload.project,
        payload.search,
        payload.size,
        payload.page
      );
      if (response) {
        commitSetReportStat(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopPerformance(
    context: ProjectContext,
    payload: {
      project: number|'';
      
      page: number;
      size: number ;
      label:any,
      model:any,
      level:number|'',
      tester:string,
      project_name:any,
      is_sub:any
    }
  ) {
    try {
      const response = await api.topPerformance(
        context.rootState.main.token,
        payload.project,
        payload.page,
        payload.size,
        payload.label,
        payload.model,
        payload.level,
        payload.tester,
        payload.project_name,
        payload.is_sub,
        
       

      );
      if (response) {
        commitSetTopPerformance(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopPerformanceList(
    context: ProjectContext,
    payload: {
      project: number|'';
      
      page: number;
      size: number ;
      project_id:any;
      model_name:any;
      version:any;
    }
  ) {
    try {
      const response = await api.topPerformanceList(
        context.rootState.main.token,
        payload.project,
        payload.page,
        payload.size,
        payload.project_id,
        payload.model_name,
        payload.version,
       
        
       

      );
      if (response) {
        commitSetTopPerformanceList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopPerformanceList_advance(
    context: ProjectContext,
    payload: {
      project: number|'';
      
      page: number;
      size: number ;
      project_id:any;
      is_valid:number,
      version:any;
      test_time:string
    }
  ) {
    try {
      const response = await api.topPerformanceList_advance(
        context.rootState.main.token,
        payload.project,
        payload.page,
        payload.size,
        payload.project_id,
        payload.is_valid,
        payload.version,
        payload.test_time,

  
       
       
        
       

      );
      if (response) {
        commitSetTopPerformanceListAdvance(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopPerformanceOld(
    context: ProjectContext,
    payload: {
      project: number|'';
      
      page: number;
      size: number ;
      label:any,
      model:any,
      level:number|'',
      tester:string,
      project_name:any,
      id_test:any
      label_main:any
    }
  ) {
    try {
      const response = await api.topPerformanceOld(
        context.rootState.main.token,
        payload.project,
        payload.page,
        payload.size,
        payload.label,
        payload.model,
        payload.level,
        payload.tester,
        payload.project_name,
        payload.id_test,
        payload.label_main,
       
        
       

      );
      if (response) {
        commitSetTopPerformanceOld(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopProjectPerformance(
    context: ProjectContext,
    payload: {
      project: number;
      
    
    }
  ) {
    try {
      const response = await api.topProjectPerformance(
        context.rootState.main.token,
        payload.project,
      

      );
      if (response) {
        commitSetTopProjectPerformance(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopOptions(
    context: ProjectContext,
    payload: {
      project: number;
      
    
    }
  ) {
    try {
      const response = await api.topOptions(
        context.rootState.main.token,
        payload.project,
      

      );
      if (response) {
        commitSetTopOptions(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopLabelPerformance(
    context: ProjectContext,
    payload: {
      project: number|'';
      project_name:any;
      
    
    }
  ) {
    try {
      const response = await api.topLabelPerformance(
        context.rootState.main.token,
        payload.project,
        payload.project_name,
      

      );
      if (response) {
        commitSetTopLabelPerformance(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopMainLabelPerformance(
    context: ProjectContext,
    payload: {
      project: number|'';
      project_name:any;
      
    
    }
  ) {
    try {
      const response = await api.topMainLabelPerformance(
        context.rootState.main.token,
        payload.project,
        payload.project_name,
      

      );
      if (response) {
        commitSetTopMainLabelPerformance(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopModelPerformance(
    context: ProjectContext,
    payload: {
      project: number|'';
      
    
    }
  ) {
    try {
      const response = await api.topModelPerformance(
        context.rootState.main.token,
        payload.project,
      

      );
      if (response) {
        commitSetTopModelPerformance(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopLevelPerformance(
    context: ProjectContext,
    payload: {
      project: number|'';
      
    
    }
  ) {
    try {
      const response = await api.topLevelPerformance(
        context.rootState.main.token,
        payload.project,
      

      );
      if (response) {
        commitSetTopLevelPerformance(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopTesterPerformance(
    context: ProjectContext,
    payload: {
      project: number|'';
      
    
    }
  ) {
    try {
      const response = await api.topTesterPerformance(
        context.rootState.main.token,
        payload.project,
      

      );
      if (response) {
        commitSetTopTesterPerformance(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopCpuList(
    context: ProjectContext,
    payload: {
      project: number|'';
      search: any;
      
    
    }
  ) {
    try {
      const response = await api.topCpuList(
        context.rootState.main.token,
        payload.project,
        payload.search,
      

      );
      if (response) {
        commitSetTopCpuList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopProjectList(
    context: ProjectContext,
    payload: {
      project: number|'';
    
      
    
    }
  ) {
    try {
      const response = await api.topProjectList(
        context.rootState.main.token,
        payload.project,
      
      

      );
      if (response) {
        commitSetTopProjectList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopProblemSummary(
    context: ProjectContext,
    payload: {
      project: number|'';
      top_project:any;
      type:any;
      version:any;

      
    
    }
  ) {
    try {
      const response = await api.topProblemSummary(
        context.rootState.main.token,
        payload.project,
        payload.top_project,
        payload.type,
        payload.version,

      
      

      );
      if (response) {
        commitSetTopProblemSummary(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopProblemByCpu(
    context: ProjectContext,
    payload: {
      project: number|'';
      type:number|'';
      cpu_name:string
    
      
    
    }
  ) {
    try {
      const response = await api.topProblemByCpu(
        context.rootState.main.token,
        payload.project,
        payload.type,
        payload.cpu_name,
      
      

      );
      if (response) {
        commitSetTopProblemByCpu(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopSceneList(
    context: ProjectContext,
    payload: {
      project: number|'';
      project_list:any,
      type:number,
      
    
    }
  ) {
    try {
      const response = await api.topSceneList(
        context.rootState.main.token,
        payload.project,
        payload.project_list,
        payload.type,
      
      

      );
      if (response) {
        commitSetTopSceneList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopSceneListVersion(
    context: ProjectContext,
    payload: {
      project: number|'';
      top_project:any,
      type:number,
      
    
    }
  ) {
    try {
      const response = await api.topSceneListVersion(
        context.rootState.main.token,
        payload.project,
        payload.top_project,
        payload.type,
      
      

      );
      if (response) {
        commitSetTopSceneListVersion(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopModelList(
    context: ProjectContext,
    payload: {
      project: number|'';
      project_list:any,
      type:number,
      scene_list:any
      
    
    }
  ) {
    try {
      const response = await api.topModelList(
        context.rootState.main.token,
        payload.project,
        payload.project_list,
        payload.type,
        payload.scene_list,
      
      

      );
      if (response) {
        commitSetTopModelList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }},
  async actionGetTopModelListVersion(
    context: ProjectContext,
    payload: {
      project: number|'';
      top_project:any,
      type:number,
      scene:any
      
    
    }
  ) {
    try {
      const response = await api.topModelListVersion(
        context.rootState.main.token,
        payload.project,
        payload.top_project,
        payload.type,
        payload.scene,
      
      

      );
      if (response) {
        commitSetTopModelListVersion(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }},
  async actionGetTopVersionList(
    context: ProjectContext,
    payload: {
      project: number|'';
      project_list:any,
      type:number,
      scene_list:any
      model_list:any
      
    
    }
  ) {
    try {
      const response = await api.topVersionList(
        context.rootState.main.token,
        payload.project,
        payload.project_list,
        payload.type,
        payload.scene_list,
        payload.model_list,
      
      

      );
      if (response) {
        commitSetTopVersionList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopProjectType(
    context: ProjectContext,
    payload: {
      project: number|'';
      project_list:any,
      type:any,
      scene_list:any
      model_list:any
      version:any
      
    
    }
  ) {
    try {
      const response = await api.topProjectType(
        context.rootState.main.token,
        payload.project,
        payload.project_list,
        payload.type,
        payload.scene_list,
        payload.model_list,
        payload.version,
      
      

      );
      if (response) {
        commitSetTopProjectType(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopVersionData(
    context: ProjectContext,
    payload: {
      project: number|'';
      top_project:any,
      type:any,
      scene:any
      model_list:any
      version_list:any
      
    
    }
  ) {
    try {
      const response = await api.topVersionData(
        context.rootState.main.token,
        payload.project,
        payload.top_project,
        payload.type,
        payload.scene,
        payload.model_list,
        payload.version_list,
      
      

      );
      if (response) {
        commitSetTopVersionData(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopVersionListVersion(
    context: ProjectContext,
    payload: {
      project: number|'';
      top_project:any,
      type:number,
      scene:any
      model_list:any
      
    
    }
  ) {
    try {
      const response = await api.topVersionListVersion(
        context.rootState.main.token,
        payload.project,
        payload.top_project,
        payload.type,
        payload.scene,
        payload.model_list,
      
      

      );
      if (response) {
        commitSetTopVersionListVersion(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTopVersionListProblem(
    context: ProjectContext,
    payload: {
      project: number|'';
      top_project:any,
      type:number,
      scene:any
      model_name:any
      
    
    }
  ) {
    try {
      const response = await api.topVersionListVersion(
        context.rootState.main.token,
        payload.project,
        payload.top_project,
        payload.type,
        payload.scene,
        payload.model_name,
      
      

      );
      if (response) {
        commitSetTopVersionListProblem(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTestAppointment(
    context: ProjectContext,
    payload: {
      project: number|'';
      start: string
      end:string
      wereport_token:any
      
    
    }
  ) {
    try {
      const response = await api.testAppointment(
        context.rootState.main.token,
        payload.project,
        payload.start,
        payload.end,
        payload.wereport_token,
      

      );
      if (response) {
        commitSetTestAppointment(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTestAppointmentAdamins(
    context: ProjectContext,
    payload: {
      project: number|'';
      wereport_token: any
      
    
    }
  ) {
    try {
      const response = await api.testAppointmentAdamins(
        context.rootState.main.token,
        payload.project,
        payload.wereport_token,
      

      );
      if (response) {
        commitSetTestAppointmentAdamins(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTestAppointmentTable(
    context: ProjectContext,
    payload: {
      project: number|'';
      is_origin: number;
      page: number;
      size: number;
      wereport_token:any;
      type?:any;
    
      
    
    }
  ) {
    try {
      const response = await api.testAppointmentTable(
        context.rootState.main.token,
        payload.project,
        payload.is_origin,
        payload.page,
        payload.size,
        payload.wereport_token,
        payload?.type,

        
      

      );
      if (response) {
        commitSetTestAppointmentTable(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTestAppointmentTableAll(
    context: ProjectContext,
    payload: {
      project: number|'';
      is_origin: number;
      page: number;
      size: number;
      wereport_token:any
      type?:any;

      
    
    }
  ) {
    try {
      const response = await api.testAppointmentTable(
        context.rootState.main.token,
        payload.project,
        payload.is_origin,
        payload.page,
        payload.size,
        payload.wereport_token,
        payload?.type,
     
        
      

      );
      if (response) {
        commitSetTestAppointmentTableAll(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTestAppointmentCreat(
    context: ProjectContext,
    payload: AppointmentCreat
  ) {
    try {
      const response = await api.testAppointmentCreat(
        context.rootState.main.token,
        payload,
      

      );
      if (response) {
       return response.data
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetVisitStatistics(
    context: ProjectContext,
    payload: {
      project: number;
      search: any | "";
      size: number | string;
      page: number;
    }
  ) {
    try {
      const response = await api.getVisitStatistics(
        context.rootState.main.token,
        payload.project,
        payload.search,
        payload.size,
        payload.page
      );
      if (response) {
        commitSetVisitStatistics(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetVisitStatTrend(
    context: ProjectContext,
    payload: { start_date: any; end_date: any }
  ) {
    try {
      const response = await api.getVisitStatTrend(
        context.rootState.main.token,
        payload.start_date,
        payload.end_date
      );
      if (response) {
        commitSetVisitStatTrend(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetMonitorTrend(
    context: ProjectContext,
    payload: { start_date: any; end_date: any }
  ) {
    try {
      const response = await api.getMonitorTrend(
        context.rootState.main.token,
        payload.start_date,
        payload.end_date
      );
      if (response) {
        commitSetMonitorTrend(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetMonitorUploadTrend(
    context: ProjectContext,
    payload: { project: number; start_date: any; end_date: any }
  ) {
    try {
      const response = await api.getMonitorUploadTrend(
        context.rootState.main.token,
        payload.project,
        payload.start_date,
        payload.end_date
      );
      if (response) {
        commitSetMonitorUploadTrend(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetMonitorList(
    context: ProjectContext,
    payload: {
      project: number;
      date: any;
      size: number | string;
      page: number;
      api: string;
    }
  ) {
    try {
      const response = await api.getmonitorList(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.size,
        payload.page,
        payload.api
      );
      if (response) {
        commitSetMonitorList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetUploadList(
    context: ProjectContext,
    payload: {
      project: number;
      date: any;
      size: number | string;
      page: number;
      api: string;
    }
  ) {
    try {
      const response = await api.getmonitorUploadList(
        context.rootState.main.token,
        payload.project,
        payload.date,
        payload.size,
        payload.page,
        payload.api
      );
      if (response) {
        commitSetMonitorUploadList(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateProjectUsers(
    context: ProjectContext,
    payload: { project: number; project_user: any[] }
  ) {
    try {
      const response = (
        await Promise.all([
          api.updateProjectUsers(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetProjectUser(store, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTestAppointmentEdit(
    context: ProjectContext,
    payload: AppointmentCreat
  ) {
     try {
      const response = (
        await Promise.all([
          api.testAppointmentEdit(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      
    }catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetTestAppointmentDelete(
    context: ProjectContext,
    payload: { id: number; project: number,wereport_token:any }
  ) {
     try {
      const response = (
        await Promise.all([
          api.testAppointmentDelete( context.rootState.main.token,
            payload.id,
            payload.project,
            payload.wereport_token),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      
    }catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetDeepPerformanceCatonDelete(
    context: ProjectContext,
    payload: { id: any; project: number }
  ) {
     try {
      const response = (
        await Promise.all([
          api.deepPerformanceCatonDelete( context.rootState.main.token,
            payload.id,
            payload.project),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      
    }catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionUpdateProjectUser(
    context: ProjectContext,
    payload: IProjectUser
  ) {
    try {
      const response = (
        await Promise.all([
          api.updateProjectUser(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetProjectUser(store, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionAddProjectUser(
    context: ProjectContext,
    payload: { project: number; username: string; is_project_admin: boolean }
  ) {
    try {
      const response = (
        await Promise.all([
          api.addProjectUser(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetProjectUser(store, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionRemoveProjectUser(
    context: ProjectContext,
    payload: { id: number; project: number }
  ) {
    try {
      const response = (
        await Promise.all([
          api.deleteProjectUser(context.rootState.main.token, payload.id,payload.project),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      commitSetProjectUser(store, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionresetProject(
    context: ProjectContext,
    payload: {
      project: number;
      file: any;
      project_name: string;
      pkg_name: string;
      ios_pkg_name: string;
    }
  ) {
    try {
      const response = (
        await Promise.all([
          api.resetProject(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      // commitSetProjectUser(context, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionCreateProjProjects(
    context: ProjectContext,
    payload: {
      project: number;
      file: any;
      project_key: string;
      project_name: string;
      pkg_name: string;
      b_invite: number;
      ios_pkg_name: string;
    }
  ) {
    try {
      const response = (
        await Promise.all([
          api.createProjProjects(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      // commitSetProjectUser(context, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
  async actionGetGamesSubscription(
    context: ProjectContext,
    payload: {
url:string,
p_skey:string,
skey:string
    }
  ) {
    try {
      const response = (
        await Promise.all([
          api.getGamesSubscription(context.rootState.main.token, payload),
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => resolve(), 500)
          ),
        ])
      )[0];
      // commitSetProjectUser(context, payload.project);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
};
  

const { dispatch } = getStoreAccessors<ProjectState | any, State>("");

export const dispatchGetProjects = dispatch(actions.actionGetProjects);
export const dispatchGetProjectDetail = dispatch(
  actions.actionGetProjectDetail
);
export const dispatchGetGamesDate = dispatch(
  actions.actionGetGamesDate
);
export const dispatchGetGamesTap= dispatch(
  actions.actionGetGamesTap
);
export const dispatchGetHokIcon= dispatch(
  actions.actionGetHokIcon
);
export const dispatchGetHokSkinVersions= dispatch(
  actions.actionGetHokSkinVersions
);
export const dispatchGetHokSkinDevices= dispatch(
  actions.actionGetHokSkinDevices
);
export const dispatchGetHokSkinData= dispatch(
  actions.actionGetHokSkinData
);
export const dispatchGetHokSkinDataPage= dispatch(
  actions.actionGetHokSkinDataPage
);
export const dispatchGetHokSkinDataExport= dispatch(
  actions.actionGetHokSkinDataExport
);
export const dispatchGetHokIn= dispatch(
  actions.actionGetHokIn
);
export const dispatchGetHokInV1= dispatch(
  actions.actionGetHokInV1
);
export const dispatchGetHokInAdd= dispatch(
  actions.actionGetHokInAdd
);
export const dispatchGetHokInAddV1= dispatch(
  actions.actionGetHokInAddV1
);
export const dispatchGetHokOutAdd= dispatch(
  actions.actionGetHokOutAdd
);
export const dispatchGetHokOutAddV1= dispatch(
  actions.actionGetHokOutAddV1
);
export const dispatchGetHokOut= dispatch(
  actions.actionGetHokOut
);
export const dispatchGetHokOutV1= dispatch(
  actions.actionGetHokOutV1
);
export const dispatchGetHokDeviceList= dispatch(
  actions.actionGetHokDeviceList
);
export const dispatchGetHokDeviceOutList= dispatch(
  actions.actionGetHokDeviceOutList
);
export const dispatchGetModelList= dispatch(
  actions.actionGetModelList
);
export const dispatchGetModelOptions= dispatch(
  actions.actionGetModelOptionst
);
export const dispatchGetModelEdit= dispatch(
  actions.actionGetModelEdit
);
export const dispatchGetModelStatus= dispatch(
  actions.actionGetModelStatus
);
export const dispatchGetModelCreate= dispatch(
  actions.actionGetModelCreate
);
export const dispatchGetHokInSkinTrend= dispatch(
  actions.actionGetHokInSkinTrend
);
export const dispatchGetHokOutSkinTrend= dispatch(
  actions.actionGetHokOutSkinTrend
);
export const dispatchGetGamesSubscription= dispatch(
  actions.actionGetGamesSubscription
);

export const dispatchGetGamesData= dispatch(
  actions.actionGetGamesData
);
export const dispatchUpdateProject = dispatch(actions.actionUpdateProject);
export const dispatchUpdateProjectScene = dispatch(
  actions.actionUpdateProjectScene
);
export const dispatchUpdateSgameSkin = dispatch(
  actions.actionUpdateSgameSkin
);
export const dispatchCreateProjectScenes = dispatch(
  actions.actionCreateProjectScenes
);
export const dispatchTopCreateProjectScenes = dispatch(
  actions.actionCreateTopProjectScenes
);
export const dispatchDeleteProjectScene = dispatch(
  actions.actionDeleteProjectScene
);
export const dispatchDeleteSgameSkin = dispatch(
  actions.actionDeleteSgameSkin
);
export const dispatchDeleteProject = dispatch(actions.actionDeleteProject);
export const dispatchCreateProject = dispatch(actions.actionCreateProject);
export const dispatchCreateProjectUser = dispatch(
  actions.actionCreateProjectUser
);
export const dispatchGetMyProjects = dispatch(actions.actionGetMyProjects);
export const dispatchGetProjectUsers = dispatch(actions.actionGetProjectUsers);
export const dispatchGetProjectUsersPage= dispatch(actions.actionGetProjectUsersPage);
export const dispatchGetReportStat = dispatch(actions.actionGetReportStat);
export const dispatchGetVisitStatistics = dispatch(
  actions.actionGetVisitStatistics
);
export const dispatchGetVisitStatTrend = dispatch(
  actions.actionGetVisitStatTrend
);
export const dispatchGetMonitorTrend = dispatch(actions.actionGetMonitorTrend);
export const dispatchGetMonitorUploadTrend = dispatch(
  actions.actionGetMonitorUploadTrend
);
export const dispatchGetMonitorList = dispatch(actions.actionGetMonitorList);
export const dispatchGetMonitorUploadList = dispatch(
  actions.actionGetUploadList
);
export const dispatchUpdateProjectUsers = dispatch(
  actions.actionUpdateProjectUsers
);
export const dispatchUpdateProjectUser = dispatch(
  actions.actionUpdateProjectUser
);
export const dispatchAddProjectUser = dispatch(actions.actionAddProjectUser);
export const dispatchRemoveProjectUser = dispatch(
  actions.actionRemoveProjectUser
);
export const dispatchGetProjectScenes = dispatch(
  actions.actionGetProjectScenes
);
export const dispatchGetTopProjectScenes= dispatch(
  actions.actionGetTopProjectScenes
);
export const dispatchGetProjectScenesPage = dispatch(
  actions.actionGetProjectScenesPage
);
export const dispatchGetProjectSgameSkinList = dispatch(
  actions.actionGetProjectSgameSkinList
);
export const dispatchGetCreateProjectSgameSkinList = dispatch(
  actions.actionGetCreateProjectSgameSkinList
);
export const dispatchProjectAccess = dispatch(actions.actionProjectAccess);
export const dispatchResetProject = dispatch(actions.actionresetProject);
export const dispatchCreateProjProjects = dispatch(
  actions.actionCreateProjProjects
);
export const dispatchCloneProject = dispatch(actions.actionCloneProject);
export const dispatchGetTopPerformance = dispatch(actions.actionGetTopPerformance);
export const dispatchGetTopPerformanceList = dispatch(actions.actionGetTopPerformanceList);
export const dispatchGetTopPerformanceListAdvance = dispatch(actions.actionGetTopPerformanceList_advance);
export const dispatchGetTopPerformanceOld = dispatch(actions.actionGetTopPerformanceOld);
export const dispatchGetTopProjectPerformance = dispatch(actions.actionGetTopProjectPerformance);
export const dispatchGetTopOptions = dispatch(actions.actionGetTopOptions);
export const dispatchGetTopLabelPerformance = dispatch(actions.actionGetTopLabelPerformance);
export const dispatchGetTopMainLabelPerformance = dispatch(actions.actionGetTopMainLabelPerformance);
export const dispatchGetTopModelPerformance = dispatch(actions.actionGetTopModelPerformance);
export const dispatchGetTopLevelPerformance = dispatch(actions.actionGetTopLevelPerformance);
export const dispatchGetTopTesterPerformance = dispatch(actions.actionGetTopTesterPerformance);
export const dispatchGetTopCpuList = dispatch(actions.actionGetTopCpuList);
export const dispatchGetTopProjectList = dispatch(actions.actionGetTopProjectList);
export const dispatchGetTopProblemSummary = dispatch(actions.actionGetTopProblemSummary);
export const dispatchGetTopProblemByCpu = dispatch(actions.actionGetTopProblemByCpu);
export const dispatchGetTopSceneList = dispatch(actions.actionGetTopSceneList);
export const dispatchGetTopSceneListVersion = dispatch(actions.actionGetTopSceneListVersion);
export const dispatchGetTopModelList = dispatch(actions.actionGetTopModelList);
export const dispatchGetTopModelListVersion = dispatch(actions.actionGetTopModelListVersion);
export const dispatchGetTopVersionList = dispatch(actions.actionGetTopVersionList);
export const dispatchGetTopProjectType = dispatch(actions.actionGetTopProjectType);
export const dispatchGetTopVersionData = dispatch(actions.actionGetTopVersionData);
export const dispatchGetTopVersionListVersion = dispatch(actions.actionGetTopVersionListVersion);
export const dispatchGetTopVersionListProblem = dispatch(actions.actionGetTopVersionListProblem);
export const dispatchGetTestAppointment = dispatch(actions.actionGetTestAppointment);
export const dispatchGetTestAppointmentAdamins = dispatch(actions.actionGetTestAppointmentAdamins);
export const dispatchGetTestAppointmentTable = dispatch(actions.actionGetTestAppointmentTable);
export const dispatchGetTestAppointmentTableAll = dispatch(actions.actionGetTestAppointmentTableAll);
export const dispatchGetTestAppointmentCreat = dispatch(actions.actionGetTestAppointmentCreat);
export const dispatchGetTestAppointmentEdit = dispatch(actions.actionGetTestAppointmentEdit);
export const dispatchGetTestAppointmentDelete= dispatch(actions.actionGetTestAppointmentDelete);
export const dispatchGetDeepPerformanceCatonDelete= dispatch(actions.actionGetDeepPerformanceCatonDelete);
